import { IdentityDto } from './../../shared/identity.dto';

export class RuleDto {
  identity?: IdentityDto;

  constructor(d?: RuleDto) {
    if (!d) {
      return;
    }

    this.identity = d.identity ? new IdentityDto(d.identity) : undefined;
  }
}
